// extracted by mini-css-extract-plugin
export default {"no-result":"zp1_z7eSUA4BLptW_w5E"};